import { useGet, useSend } from '../../useApi';

export interface AdminReceipt {
  id: string;
  number: string;
  kind: 'BILL' | 'PAYMENT';
  issued_at: string;
  times_verified: number;
  withdrawn_at: string | null;
  withdrawn_by: string | null;
  withdraw_reason: string | null;
}

// GET /admin/transactions/{id}/receipts and POST /admin/receipts/{id}/withdraw.
// A receipt's contents can't be edited, only withdrawn (limits spec R7).
const useTransactionReceipts = () => {
  const { data, fetch } = useGet<AdminReceipt[]>('Failed to load receipts');
  const { loading, send } = useSend('Could not withdraw the receipt');
  const fetchReceipts = (transactionId: string) => fetch(`api/v1/admin/transactions/${transactionId}/receipts`);
  return {
    receipts: data ?? [],
    withdrawing: loading,
    fetchReceipts,
    withdraw: (transactionId: string, receiptId: string, reason: string) =>
      send({ url: `api/v1/admin/receipts/${receiptId}/withdraw`, method: 'post', data: { reason } }, () => fetchReceipts(transactionId)),
  };
};

export default useTransactionReceipts;
